export const SPRITES = {
  ACTIONS: {
    width: 250,
    height: 250,
    columns: 4,
    class: "ACTIONS",
  },
  ENEMIES: {
    width: 370,
    height: 570,
    columns: 7,
    class: "ENEMIES",
  },
  ITEMS_FRONT: {
    width: 277,
    height: 428,
    columns: 9,
    class: "ITEMS_FRONT",
  },
  ITEMS_BACK: {
    width: 277,
    height: 428,
    columns: 6,
    class: "ITEMS_BACK",
  },
  PLAYERBOARD: {
    width: 848,
    height: 538,
    columns: 3,
    class: "PLAYERBOARD",
  },
  CRAFTING_TABLE: {
    width: 848,
    height: 538,
    fullWidth: 1674,
    columns: 3,
    class: "CRAFTING_TABLE",
  },
  TOKENS: {
    width: 260,
    height: 260,
    fullWidth: 1040,
    columns: 4,
    class: "TOKENS",
  },
  AVATAR: {
    width: 350,
    height: 450,
    fullWidth: 2800,
    columns: 8,
    class: "AVATAR",
  },
  SKILLS: {
    width: 996,
    height: 996,
    fullWidth: 996,
    columns: 8,
    class: "SKILLS",
  },
  BG: {
    width: 1758,
    height: 499,
    fullWidth: 1996,
    columns: 1,
    class: "BG",
  },
  POTION: {
    width: 277,
    height: 428,
    fullWidth: 1662,
    columns: 6,
    class: "POTION",
  },
  DICE: {
    width: 100,
    height: 100,
    fullWidth: 800,
    columns: 8,
    class: "DICE",
  },
};

export const TYPE_SPRITE_MAP = {
  MONSTER: "ENEMIES",
  KING: "ENEMIES",
  PLAYERBOARD: "PLAYERBOARD",
  ACTIONS: "ACTIONS",
  ITEM_FRONT: "ITEMS_FRONT",
  ITEM_BACK: "ITEMS_BACK",
  AVATAR: "AVATAR",
  SKILLS: "SKILLS",
  BG: "BG",
  POTION: "POTION",
  DICE: "DICE",
};
